export const validateEmail = (email) => { // contains text on both sides of @ as well as a top level domain (.com, .net, etc)
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
};

export const validateUsernameOrPassword = (username_or_password) => {
    return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(username_or_password); // At least 8 characters, one letter, one number
};

export const trackingColors = { //change color depending on tracking
    "unknown": "gray",
    "pre_transit": "red",
    "in_transit": "#FFC107",
    "out_for_delivery": "green",
    "delivered": "black"
};

//take items out of list that have already been removed on Shopify
export const eliminateRemovedItems = (cleanedRemovedItems, updatedLineItems) => {
    cleanedRemovedItems.forEach((removedItem) => {
        const matchingLineItems = updatedLineItems
            .map((item, index) => {
                const cleanedName = `${item.productTitle} ${item.variantTitle}`
                    .replace(/[\/\-]/g, " ")
                    .replace(/\s+/g, " ")
                    .toLowerCase()
                    .trim();
                return { item, index, cleanedName };
            })
            .filter((entry) => entry.cleanedName === removedItem.name)
            .sort((a, b) => b.item.productQuantity - a.item.productQuantity);
        let remainingToRemove = removedItem.quantity;
        for (const { item, index } of matchingLineItems) {
            if (remainingToRemove <= 0) break;
            const removableQty = Math.min(
                remainingToRemove,
                item.productQuantity
            );

            updatedLineItems[index].productQuantity -= removableQty;
            remainingToRemove -= removableQty;
        }
    });
    return updatedLineItems.filter((item) => item.productQuantity > 0);
};

export const highlightOptionBorder = (hoveredOption, option) => {
    return hoveredOption === option
        ? { boxShadow: "0 4px 20px 0 rgba(0, 0, 0, .5), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }
        : { boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.3), 0 3px 10px 0 rgba(0, 0, 0, 0.1)" };
};

export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

//animated ellipses for loading
export const startEllipsisInterval = (setTextFn, baseText = "loading") => {
    let dots = 1;
        const interval = setInterval(() => {
        setTextFn(`${baseText}${".".repeat(dots)}`);
        dots = dots === 3 ? 1 : dots + 1;
    }, 250);
    return interval;
};

export const fetchReturnData = async (token, apiUrl, setOrderData, setTotalCost, setError, setEditableFields, getExchangeData) => {
    try {
        const response = await fetch(`${apiUrl}/api/return_details/${token}/?get_exchange_data=${getExchangeData}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) throw new Error("Failed to fetch return details");
        const data = await response.json();
        setOrderData(data);
        setTotalCost(data.order_total_cost);
        setEditableFields({
            business_name: data.business_name,
            customer_name: data.customer_name,
            customer_email: data.customer_email,
            customer_address: data.customer_address,
            ship_to_address: data.ship_to_address,
            length: data.length,
            width: data.width,
            height: data.height,
            weight: data.weight,
        });
    } catch (err) { 
        console.log("error fetching return data: ", err)
        setError(err.message); 
    }
};

//retrieve existing set of all default feedback reasons for a business
export const getAllChoices = async (apiUrl, token) => {
    try {
        const response = await fetch(`${apiUrl}/api/get_feedback_reasons/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return (data.choices)
    } catch (error) { console.error("Error fetching choices:", error); }
}

//retrieve existing set of feedback reasons for the selectedProduct
export const getExchangeProductChoices = async (apiUrl, token, selectedProduct) => {
    try {
        const response = await fetch(`${apiUrl}/api/get_exchange_product_feedback_reasons/?product_id=${encodeURIComponent(selectedProduct)}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return (data.choices);
    } catch (error) { console.error("Error fetching choices for selected product:", error); }
}

//retrieve default configuration for package weight and dimensions
export const getDefaultPackageWeightAndDimensions = async (apiUrl, token) => {
    try {
        const response = await fetch(`${apiUrl}/api/get_default_package_weight_and_dimensions/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return (data);
    } catch (error) { console.error("Error fetching default package weight and dimensions:", error); }
}

//map to correct carrier string
const carriers = ["USPS", "UPS", "FedEx", "DHL"];
export const getCarrier = (carrier) => {
    const match = carriers.find(c => carrier.includes(c));
    return (match);
};